export const COMPANY = {
  name: "Wilshire Buildcon Co.",
  tagline: "Buy. Sell. Rent. With Trust.",
  phone: "+91 62612 27048",
  phoneRaw: "916261227048",
  email: "wilshirebuildcon@gmail.com",
  address: "MZ-102, Sonam Plaza, Nemawar Road, Navlakha, Indore, Madhya Pradesh, 452001",
  city: "Indore",
  logo: "https://customer-assets.emergentagent.com/job_c2d60326-c63d-4493-a9f3-05c9809e41ff/artifacts/xu6a5ozf_logo.jpeg",
  mdPhoto: "https://customer-assets.emergentagent.com/job_c2d60326-c63d-4493-a9f3-05c9809e41ff/artifacts/5zdfswwa_BHM%20GROUP.jpg",
  mdName: "Mr. B. S. Rajput",
  mdTitle: "Founder & Managing Director",
};

export const WHATSAPP_URL = (msg = "Hello Wilshire Buildcon, I would like to know more about your property services.") =>
  `https://wa.me/${COMPANY.phoneRaw}?text=${encodeURIComponent(msg)}`;

export const CATEGORIES = [
  { key: "plot", label: "Plots & Land", img: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=85" },
  { key: "commercial", label: "Commercial", img: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&q=85" },
  { key: "office", label: "Office Spaces", img: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=85" },
  { key: "warehouse", label: "Warehouses", img: "https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200&q=85" },
  { key: "factory", label: "Factories", img: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=1200&q=85" },
  { key: "residential", label: "Residential", img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=85" },
  { key: "villa", label: "Villas", img: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1200&q=85" },
  { key: "farmhouse", label: "Farm Houses", img: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1200&q=85" },
  { key: "building", label: "Buildings", img: "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1200&q=85" },
  { key: "showroom", label: "Showrooms", img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&q=85" },
  { key: "colony", label: "Colony Development", img: "https://images.unsplash.com/photo-1449844908441-8829872d2607?w=1200&q=85" },
];

export const SERVICES = [
  { title: "Property Buying", desc: "End-to-end assistance in purchasing verified residential, commercial and industrial properties.", icon: "Home" },
  { title: "Property Selling", desc: "Reach genuine buyers Pan India with our marketing, valuation and negotiation expertise.", icon: "Tag" },
  { title: "Property Leasing", desc: "Long term leasing solutions for offices, warehouses, retail and residential spaces.", icon: "Key" },
  { title: "Legal Documentation", desc: "Registry, sale deed, title verification and complete legal due diligence.", icon: "FileCheck" },
  { title: "Investment Advisory", desc: "Market analysis, ROI projections and portfolio guidance for property investors.", icon: "TrendingUp" },
  { title: "Property Valuation", desc: "Certified market-based valuation for buying, selling, loan and insurance purposes.", icon: "Calculator" },
  { title: "Project Development", desc: "Colony development, plotting, farmhouse projects and construction services.", icon: "Building2" },
  { title: "Commercial Consulting", desc: "Specialized advisory for offices, warehouses, factories and industrial units.", icon: "Briefcase" },
];

export const TESTIMONIALS = [
  { name: "Rajesh Sharma", city: "Indore", quote: "Wilshire Buildcon made buying our dream villa completely stress-free. Transparent, professional and always responsive.", rating: 5 },
  { name: "Priya Malhotra", city: "Bhopal", quote: "The team helped us lease a Grade A office in Vijay Nagar within 2 weeks. Their commercial expertise is unmatched.", rating: 5 },
  { name: "Amit Patel", city: "Pithampur", quote: "Excellent industrial property consultation. They understood our factory requirements perfectly.", rating: 5 },
  { name: "Sneha Verma", city: "Indore", quote: "From documentation to registry, everything was handled end-to-end. Highly recommend for first time buyers.", rating: 5 },
];

export const STATS = [
  { value: "500+", label: "Properties Listed" },
  { value: "12+", label: "Years of Trust" },
  { value: "Pan India", label: "Presence" },
  { value: "100%", label: "Verified Deals" },
];

// Area unit conversion (all to sqft)
export const AREA_UNITS = {
  sqft: { label: "Square Feet (sq.ft)", toSqft: 1 },
  sqyd: { label: "Square Yard (sq.yd)", toSqft: 9 },
  gaj: { label: "Gaj", toSqft: 9 },
  sqm: { label: "Square Meter (sq.m)", toSqft: 10.7639 },
  acre: { label: "Acre", toSqft: 43560 },
  hectare: { label: "Hectare", toSqft: 107639 },
  bigha: { label: "Bigha (MP)", toSqft: 27000 },
  biswa: { label: "Biswa", toSqft: 1350 },
  marla: { label: "Marla", toSqft: 272.25 },
  kanal: { label: "Kanal", toSqft: 5445 },
};

export function convertArea(value, fromUnit, toUnit) {
  if (!value || isNaN(value)) return 0;
  const sqft = value * AREA_UNITS[fromUnit].toSqft;
  return sqft / AREA_UNITS[toUnit].toSqft;
}

export function calculateEMI(principal, annualRate, years) {
  const r = annualRate / 12 / 100;
  const n = years * 12;
  if (r === 0) return principal / n;
  const emi = (principal * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
  return emi;
}

export function calculateStampDuty(propertyValue, gender = "male", municipal = true) {
  // MP: Men ~ 7.5% stamp + 3% registration (approx), Women 5% + 3%
  const stampRate = gender === "female" ? 0.05 : 0.075;
  const regRate = 0.03;
  const municipalTax = municipal ? 0.005 : 0;
  const stamp = propertyValue * stampRate;
  const reg = propertyValue * regRate;
  const muni = propertyValue * municipalTax;
  return { stamp, registration: reg, municipal: muni, total: stamp + reg + muni };
}

export function formatINR(num) {
  if (num >= 10000000) return `₹ ${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹ ${(num / 100000).toFixed(2)} L`;
  return `₹ ${num.toLocaleString('en-IN')}`;
}
